
<template>
    <ListDialog ref="StockBalanceDialog" :title="$parent.formatTitle('在庫一覧表')"  :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="StockBalanceReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【在庫一覧表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
        <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="倉庫" :value.sync="warehouse" :editor="editor" :needsWarehouse="true" tooltip="ここで倉庫を選択をすると、選択した倉庫だけのデータを出力する事ができます。選択しない場合はすべての倉庫のデータが出力できます。" />
        <AtcCategory title="商品区分" :categoryGroup="categoryGroupCommodity" :value.sync="commodityCategory" tooltip="ここで商品区分を選択をすると、選択した区分だけのデータを出力する事ができます。選択しない場合はすべての区分のデータが出力できます。" />
	      <Calendar title="限月" :editor="editor" :value.sync="closingDate" :deletable="false" :required="true" :month="true"  :autoEntry="true" :dateFlag.sync="closingDateFlag"  tooltip="データを出力する月を指定します。選択した月の月初から月末までのデータが帳票に出力されます。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>             
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptStockBalance extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public commodityCategory: number = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public closingDate: Date = null;
  public onExcelExport :boolean = false;
  public closingDateFlag : Common.dateFlags = Common.dateFlags.default;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.StockBalanceReportTemplateQuery = new Common.StockBalanceReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.closingDate = new Date().getCalendarDate();

    (this.$refs.StockBalanceDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.StockBalanceReportQuery = new Common.StockBalanceReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.commodityCategory = this.commodityCategory;
    query.warehouse = this.warehouse;
    query.closingDate = this.closingDate;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
